<template lang="pug">
  include ./../../../mixins
  div.rel(style='height: 100%')
    +b.swiper.v-swiper(
      :class='`v-swiper--${this.sliderTag}`'
    )
      +b.swiper-wrapper
        slot(name="slide")
</template>

<script>
import Swiper from 'swiper/swiper-bundle.esm.browser';

export default {
  components: {
    Swiper,
  },
  data() {
    return {}
  },
  props: {
    sliderTag: String,
  },
  mounted() {
    // eslint-disable-next-line no-unused-vars
    const swiper = new Swiper(`.v-swiper--${this.sliderTag}`, {
      observer: true,
      observeParents: true,
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        nextEl: `.swiper-next-${this.sliderTag}`,
        prevEl: `.swiper-prev-${this.sliderTag}`,
      },
      breakpoints: {
        1700: {
          slidesPerView: 3,
          spaceBetween: 60,
        },
        1500: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1200: {
          slidesPerView: 2,
          spaceBetween: 60,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 15,
        },
        992: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
      },
    });
  },
}
</script>



// WEBPACK FOOTER //
// ./src/js/components/app/UiElements/UiSwiper.vue